define('OrderWizard.Module.CaptchaVerification', [
	'googlecaptcha.tpl',
	'jQuery',
	'Wizard.Module'
], function OrderWizardModuleCaptchaVerification(
	googleCaptchaTpl,
	jQuery,
	WizardModule
) {
	'use strict';

	return WizardModule.extend({
		template: googleCaptchaTpl,
		getContext: function getContext() {
			return {};
		},
		submit: function submit() {
			var captchaPromise = jQuery.Deferred();
			var env = this.wizard.application.getComponent('Environment');
			var self = this;
			grecaptcha.ready(function addGooglecaptchaToken() {
				grecaptcha.execute(env.getConfig('googlecaptcha.siteKey'), { action: 'order' }).then(function executeCaptchaThen(token) {
					self.model.set({
						'grecaptcha-token': token
					});
					captchaPromise.resolve();
				});
			});

			return captchaPromise;
		}

	});
});
